import { ReactComponent as CopyIcon } from 'app/assets/img/copy-icon.svg';
import { ReactComponent as EmptyImg } from 'app/assets/img/empty.svg';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { LoadingContainer } from 'app/components/LoadingContainer';
import useFetchData from 'app/hooks/useFetchData';
import { createCheckoutPaymentApi } from 'app/services/checkoutApi';
import {
  getCommonAirportDataApi,
  postCancelOrderHolidayApi,
} from 'app/services/holidayApi';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { selectTranslations } from '../App/slice/selectors';
import { useHolidayOrderDetail } from '../HolidayCheckout/hooks/useHolidayOrderDetail';
import ComboInformation from './ComboInformation';
import ContactInformation from './ContactInformation';
import FlightInformation from './FlightInformation';
import OrderCard from './OrderCard';
import PassengerInformation from './PassengerInformation';
import { HolidayOrderDetailWrapper } from './styled';
import { IHolidayOrderDetail } from '../HolidayCheckout/types';
import { FareFamilyData, getAllFareFamilies } from 'app/services/fareFamilyApi';
import { useCountries } from '../PassengerInfo/hooks/useCountries';
import { approveOrderApi, rejectOrderApi } from '../OrderApproval/api';
export const HolidayOrderDetail = () => {
  const { id }: { id: string } = useParams();
  const history = useHistory();
  const translations = useSelector(selectTranslations);
  const [dataInfo, setDataInfo] = useState<IHolidayOrderDetail | null>(null);
  const [dataAirports, setDataAirports] = useState<any>();
  const [isLoadingRejectApprove, setIsLoadingRejectApprove] =
    useState<boolean>(false);
  const [fareFamilies, setFareFamilies] = useState<FareFamilyData[]>([]);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const { onFetchOrderDetail, isLoading: isLoadingDetail } =
    useHolidayOrderDetail({
      shouldValidate: false,
      onSuccess: response => {
        setDataInfo(response);
      },
    });
  const { onFetchData: onFetchAirport } = useFetchData({
    actionApi: getCommonAirportDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataAirports(response.data);
    },
  });
  const { countries: countryOptions } = useCountries();
  useEffect(() => {
    onFetchAirport();
    getAllFareFamilies().then(setFareFamilies);
  }, []);
  useEffect(() => {
    if (id) {
      onFetchOrderDetail({ payloadData: { orderCode: id } });
    }
  }, [id]);
  const onPayNow = () => {
    const formData = new FormData();
    formData.append('idHash', dataInfo?.idHash ?? '');
    formData.append('queryCallback', '');
    formData.append('type', 'holiday');
    onFetchCreateCheckout({ payloadData: formData });
  };
  const onClickPaymentNow = () => {
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: translations?.['b2b.text.notify'] ?? '',
      content: translations?.['b2b.txt.confirmPaymentQuestion'],
      buttons: [
        {
          text: translations?.['b2b.txt.no'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2b.txt.yes'] ?? '',
          bg: 'var(--color-gradient)',
          color: 'white',
          onClick: () => {
            onCloseDialogNoti();
            onPayNow();
          },
        },
      ],
      maskClosable: false,
      onCloseDialog: onCloseDialogNoti,
    });
  };
  const onTimeout = () => {
    onFetchCancelOrder({ payloadData: { idHash: dataInfo?.idHash ?? '' } });
  };
  const { onFetchData: onFetchCreateCheckout, isLoading: isLoadingCheckout } =
    useFetchData({
      actionApi: createCheckoutPaymentApi,
      IIFE: false,
      onSuccess: response => {
        if (!dataInfo?.orderCode) return;
        if (response?.paymentSuccess) {
          onFetchOrderDetail({
            payloadData: { orderCode: dataInfo.orderCode },
          });
        } else {
          onOpenDialogNoti({
            type: 'ERROR',
            isShow: true,
            title: translations?.['b2b.txt.payment-deposit-fail'] ?? '',
            content: response?.message ?? '',
            closable: true,
            onCloseDialog: onCloseDialogNoti,
            maskClosable: false,
          });
        }
      },
    });
  const { onFetchData: onFetchCancelOrder, isLoading: isLoadingCancelOrder } =
    useFetchData({
      actionApi: postCancelOrderHolidayApi,
      IIFE: false,
      onSuccess: response => {
        if (!dataInfo?.orderCode) return;
        onFetchOrderDetail({
          payloadData: { orderCode: dataInfo.orderCode },
        });
      },
    });
  const onCancelOrder = () => {
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: translations?.['b2b.text.notify'] ?? '',
      content: translations?.['b2b.txt.confirmCancelBookingQuestion'],
      buttons: [
        {
          text: translations?.['b2b.txt.no'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2b.txt.yes'] ?? '',
          bg: 'var(--color-gradient)',
          color: 'white',
          onClick: () => {
            onCloseDialogNoti();
            onTimeout();
          },
        },
      ],
      maskClosable: false,
      onCloseDialog: onCloseDialogNoti,
    });
  };
  const onReject = async () => {
    if (!dataInfo) return;
    setIsLoadingRejectApprove(true);
    try {
      await rejectOrderApi(String(dataInfo.idHash));
      onOpenDialogNoti({
        type: 'SUCCESS',
        isShow: true,
        title: translations?.['b2b.text.notify'] ?? '',
        content:
          translations?.['b2b.txt.rejectOrderSuccess'] ??
          'Quý khách đã từ chối đơn hàng thành công',
        maskClosable: false,
        onCloseDialog: () => {
          onCloseDialogNoti();
          history.push('/approve-order?tab=holiday');
        },
      });
    } catch (error: any) {
      let messageError = '';
      if (error.errorCode === 'MSG022') {
        messageError =
          translations?.['b2b.txt.orderCanceledBySale'] ||
          'MSG022: Đơn hàng đã bị hủy bởi sale';
      } else if (error.errorCode === 'MSG023') {
        messageError =
          translations?.['b2b.txt.orderHoldExpired'] ||
          'MSG023: Đơn hàng đã hết thời gian giữ';
      } else {
        messageError =
          error.message ||
          translations?.['b2b.txt.rejectError'] ||
          'Có lỗi xảy ra khi từ chối đơn hàng';
      }
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: translations?.['b2b.text.notify'] ?? '',
        content: messageError,
        maskClosable: false,
        onCloseDialog: () => {
          onCloseDialogNoti();
          onFetchOrderDetail({
            payloadData: { orderCode: dataInfo.orderCode },
          });
        },
      });
    } finally {
      setIsLoadingRejectApprove(false);
    }
  };
  const onClickApprove = async () => {
    if (!dataInfo) return;
    setIsLoadingRejectApprove(true);
    try {
      await approveOrderApi(String(dataInfo.idHash));
      onOpenDialogNoti({
        type: 'SUCCESS',
        isShow: true,
        title: translations?.['b2b.text.notify'] ?? '',
        content:
          translations?.['b2b.txt.approveOrderSuccess'] ||
          'Quý khách đã phê duyệt đơn hàng thành công',
        maskClosable: false,
        onCloseDialog: () => {
          onCloseDialogNoti();
          history.push('/approve-order?tab=holiday');
        },
      });
    } catch (error: any) {
      let messageError = '';
      if (error.errorCode === 'MSG022') {
        messageError =
          translations?.['b2b.txt.orderCanceledBySale'] ||
          'MSG022: Đơn hàng đã bị hủy bởi sale';
      } else if (error.errorCode === 'MSG023') {
        messageError =
          translations?.['b2b.txt.orderHoldExpired'] ||
          'MSG023: Đơn hàng đã hết thời gian giữ';
      } else {
        messageError =
          error.message ||
          translations?.['b2b.txt.approveError'] ||
          'Có lỗi xảy ra khi phê duyệt đơn hàng';
      }
      onOpenDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: translations?.['b2b.text.notify'] ?? '',
        content: messageError,
        maskClosable: false,
        onCloseDialog: () => {
          onCloseDialogNoti();
          onFetchOrderDetail({
            payloadData: { orderCode: dataInfo.orderCode },
          });
        },
      });
    } finally {
      setIsLoadingRejectApprove(false);
    }
  };
  return (
    <LoadingContainer
      loading={
        isLoadingDetail ||
        isLoadingCheckout ||
        isLoadingCancelOrder ||
        isLoadingRejectApprove
      }
    >
      {!isLoadingDetail && (
        <>
          <ContainerFluid>
            {!_.isEmpty(dataInfo) ? (
              <HolidayOrderDetailWrapper>
                <TitlePage>{translations?.['b2b.order.title']}</TitlePage>
                <OrderCard
                  orderState={dataInfo?.orderState?.value || 'paymentPending'}
                  dataInfo={dataInfo}
                  onClickPaymentNow={onClickPaymentNow}
                  onTimeout={onTimeout}
                  onCancel={onCancelOrder}
                  onReject={onReject}
                  onClickApprove={onClickApprove}
                />
                <BoxPassengerInformation>
                  <Title>{translations?.['b2b.txt.productInformation']}</Title>
                  <Line />
                  {dataInfo && <ComboInformation dataInfo={dataInfo} />}
                </BoxPassengerInformation>
                <BoxPassengerInformation>
                  <Title>{translations?.['b2b.txt.orderInfo']}</Title>
                  <Line />
                  <FlightInformation
                    flightInfo={dataInfo?.orderItems?.flights}
                    comboInfo={dataInfo?.orderItems?.tickets}
                    hotelInfo={dataInfo?.orderItems?.hotels}
                    dataAirports={dataAirports}
                    fareFamilies={fareFamilies}
                    note={dataInfo?.note || ''}
                  />
                </BoxPassengerInformation>
                <BoxPassengerInformation>
                  <Title>
                    {translations?.['b2b.txt.passengerInformation']}
                  </Title>
                  <Line />
                  <PassengerInformation
                    dataPassenger={dataInfo.passengers}
                    countryOptions={countryOptions}
                  />
                </BoxPassengerInformation>
                <BoxPassengerInformation>
                  <Title>{translations?.['b2c.ref.contactInfo']}</Title>
                  <Line />
                  <ContactInformation dataContact={dataInfo.contact} />
                </BoxPassengerInformation>
              </HolidayOrderDetailWrapper>
            ) : (
              <>
                <EmptyImg style={{ margin: 'auto', marginTop: 30 }} />
              </>
            )}
          </ContainerFluid>
        </>
      )}
    </LoadingContainer>
  );
};
const TitlePage = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
`;
const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
const SubTitle = styled.div`
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
`;
const Line = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  margin: 12px -11px;
`;
const BoxPassengerInformation = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
`;
const CopyButton = styled.div`
  border: none;
  padding: 0 12px;
  cursor: pointer;
  // width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 50px;
`;
const CopyIconCss = styled(CopyIcon)`
  height: 15px;
  filter: brightness(0) saturate(100%) invert(64%) sepia(63%) saturate(1246%)
    hue-rotate(345deg) brightness(99%) contrast(101%);
`;
const TickIcon = styled.div`
  height: 10px;
  width: 20px;
  color: var(--color-9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
`;
